class Toolbar extends HTMLElement {
    constructor() {
        if (
            (super(),
            (this.stickyBounds = document.getElementById("CollectionProductGrid").querySelector(".productListing")),
            this.queryParams(),
            this.closeModalClick(),
            this.querySelector("[data-view-as]"))
        ) {
            (this.mediaView = this.querySelector("[data-view-as]")),
                (this.mediaViewMobile = this.querySelector("[data-view-as-mobile]")),
                this.mediaView.querySelectorAll(".icon-mode").forEach((modeButton) => {
                    modeButton.addEventListener("click", this.onClickModeButtonHandler.bind(this));
                }),
                this.mediaViewMobile.querySelectorAll(".icon-mode").forEach((modeMobileButton) => {
                    modeMobileButton.addEventListener("click", this.onClickModeButtonMobileHandler.bind(this));
                }),
                (this.debouncedOnResizeMediaQuery = debounce(() => {
                    this.setActiveViewModeMediaQuery(!1);
                }, 200));
            var w = window.innerWidth;
            window.addEventListener("resize", () => {
                window.innerWidth != w && ((w = window.innerWidth), this.debouncedOnResizeMediaQuery());
            }),
                window.addEventListener("load", () => {
                    this.debouncedOnResizeMediaQuery();
                });
        }
        this.querySelector("[data-limited-view]") &&
            ((this.limitView = this.querySelector("[data-limited-view]")),
            this.limitView.querySelectorAll("[data-limited-view-item]").forEach((limitButton) => {
                limitButton.addEventListener("click", this.onClickLimitButtonHandler.bind(this));
            })),
            this.querySelector("[data-toggle]") &&
                (this.querySelectorAll("[data-toggle]").forEach((dropdownButton) => {
                    dropdownButton.addEventListener("click", this.onClickDropdownButtonHandler.bind(this));
                }),
                window.addEventListener("load", () => {
                    document.body.addEventListener("click", this.onBodyClickEvent.bind(this));
                })),
            this.querySelector("[data-sorting]") &&
                ((this.sortBys = this.querySelectorAll("[data-sorting]")),
                this.sortBys[0].querySelector("[data-sort-by-item]") != null &&
                    this.sortBys.forEach((sortBy) => {
                        sortBy.querySelectorAll("[data-sort-by-item]").forEach((sortByButton) => {
                            sortByButton.addEventListener("click", this.onClickSortByButtonHandler.bind(this));
                        });
                    })),
            this.checkNeedToConvertCurrency() &&
                Currency.convertAll(
                    window.shop_currency,
                    $("#currencies .active").attr("data-currency"),
                    "span.money",
                    "money_format"
                );
    }
    queryParams() {
        if (((Shopify.queryParams = {}), location.search.length > 0))
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&"); i < aCouples.length; i++)
                (aKeyValue = aCouples[i].split("=")),
                    aKeyValue.length > 1 &&
                        (Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]));
    }
    createURLHash(baseLink) {
        var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, "+");
        return baseLink
            ? newQuery != ""
                ? baseLink + "?" + newQuery
                : baseLink
            : newQuery != ""
              ? location.pathname + "?" + newQuery
              : location.pathname;
    }
    updateURLHash(baseLink) {
        delete Shopify.queryParams.page;
        var newUrl = this.createURLHash(baseLink);
        history.pushState({ param: Shopify.queryParams }, newUrl, newUrl);
    }
    checkNeedToConvertCurrency() {
        var currencyItem = $(".dropdown-item[data-currency]");
        if (currencyItem.length)
            return (
                (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) ||
                window.show_auto_currency
            );
    }
    onClickDropdownButtonHandler(event) {
        var buttonElement = event.currentTarget;
        buttonElement.dataset.mobile === "mobile" && document.body.classList.add("toolbar-modal-open"),
            buttonElement.getAttribute("aria-expanded") === "false"
                ? buttonElement.setAttribute("aria-expanded", !0)
                : buttonElement.setAttribute("aria-expanded", !1);
    }
    onClickSortByButtonHandler(event) {
        event.preventDefault();
        var buttonElement = event.currentTarget;
        if (((this.sortBy = buttonElement.closest("[data-sorting]")), !buttonElement.classList.contains("is-active"))) {
            var value = buttonElement.querySelector(".text").getAttribute("data-value"),
                href = buttonElement.querySelector(".text").getAttribute("data-href"),
                text = buttonElement.querySelector(".text").innerText;
            if (
                (this.sortBy.querySelector(".label-text") != null &&
                    (this.sortBy.querySelector(".label-text").innerText = text),
                this.sortBy.querySelector("[data-toggle]") != null &&
                    this.sortBy.querySelector("[data-toggle]")?.setAttribute("aria-expanded", !1),
                this.sortBy.querySelectorAll("[data-sort-by-item]").forEach((sortByButton) => {
                    sortByButton.classList.remove("is-active");
                }),
                buttonElement.classList.add("is-active"),
                this.sortBy.dataset.mobile === "mobile" &&
                    (this.querySelector('[data-toggle][data-mobile="mobile"]').setAttribute("aria-expanded", !1),
                    document.body.classList.remove("toolbar-modal-open")),
                window.show_storefront_filter)
            ) {
                const form = document.querySelector("collection-filters-form");
                (form.querySelector('[name="sort_by"]').value = href),
                    form.onSubmitHandlerFromSortBy(event, form.querySelector("form"));
            } else {
                (Shopify.queryParams.sort_by = href), this.updateURLHash();
                var newUrl = this.createURLHash();
                this.renderPage(newUrl);
            }
        }
    }
    getSections() {
        return [
            {
                id: "main-collection-product-grid",
                section: document.getElementById("main-collection-product-grid").dataset.id,
            },
        ];
    }
    renderPage(href) {
        const sections = this.getSections();
        document.body.classList.add("has-halo-loader"),
            sections.forEach((section) => {
                this.renderSectionFromFetch(href, section);
            });
    }
    renderSectionFromFetch(url, section) {
        fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
                const html = responseText;
                this.renderSidebar(html), this.renderProductGrid(html);
            });
    }
    renderSidebar(html) {
        if (document.getElementById("main-collection-filters")) {
            const innerHTML = new DOMParser()
                .parseFromString(html, "text/html")
                .getElementById("main-collection-filters").innerHTML;
            document.getElementById("main-collection-filters").innerHTML = innerHTML;
        }
    }
    renderProductGrid(html) {
        const innerHTML = new DOMParser()
            .parseFromString(html, "text/html")
            .getElementById("CollectionProductGrid")
            .querySelector(".collection").innerHTML;
        (document.getElementById("CollectionProductGrid").querySelector(".collection").innerHTML = innerHTML),
            this.setActiveViewModeMediaQuery(!0),
            window.compare.show &&
                this.setLocalStorageProductForCompare({ link: $("[data-compare-link]"), onComplete: null }),
            window.wishlist.show && this.setLocalStorageProductForWishlist(),
            window.innerWidth < 1025 &&
                window.scrollTo({
                    top:
                        document.getElementById("CollectionProductGrid").getBoundingClientRect().top +
                        window.pageYOffset -
                        50,
                    behavior: "smooth",
                }),
            document.body.classList.remove("has-halo-loader");
    }
    setLocalStorageProductForCompare($link) {
        var count = JSON.parse(localStorage.getItem("compareItem")),
            items = $("[data-product-compare-handle]");
        count !== null &&
            items.length > 0 &&
            items.each((index, element) => {
                var item = $(element),
                    handle = item.data("product-compare-handle");
                count.indexOf(handle) >= 0
                    ? (item.find(".compare-icon").addClass("is-checked"),
                      item.find(".text").text(window.compare.added),
                      item.find("input").prop("checked", !0))
                    : (item.find(".compare-icon").removeClass("is-checked"),
                      item.find(".text").text(window.compare.add),
                      item.find("input").prop("checked", !1));
            });
    }
    setLocalStorageProductForWishlist() {
        var wishlistList = localStorage.getItem("wishlistItem") ? JSON.parse(localStorage.getItem("wishlistItem")) : [];
        localStorage.setItem("wishlistItem", JSON.stringify(wishlistList)),
            wishlistList.length > 0 &&
                ((wishlistList = JSON.parse(localStorage.getItem("wishlistItem"))),
                wishlistList.forEach((handle) => {
                    this.setProductForWishlist(handle);
                })),
            $("[data-wishlist-count]").text(wishlistList.length);
    }
    setProductForWishlist(handle) {
        var wishlistList = JSON.parse(localStorage.getItem("wishlistItem")),
            item = $('[data-wishlist-handle="' + handle + '"]'),
            index = wishlistList.indexOf(handle);
        index >= 0
            ? item.addClass("wishlist-added").find(".text").text(window.wishlist.added)
            : item.removeClass("wishlist-added").find(".text").text(window.wishlist.add);
    }
    setActiveViewModeMediaQuery(ajaxLoading = !0) {
        var viewMode = this.mediaView?.querySelector(".icon-mode.active"),
            viewModeMobile = this.mediaViewMobile?.querySelector(".icon-mode.active"),
            column = parseInt(viewMode?.dataset.col),
            windowWidth = window.innerWidth;
        column != 1
            ? (document.querySelector(".sidebar--layout_vertical")
                  ? windowWidth < 768
                      ? (column == 3 || column == 4 || column == 5) &&
                        ((column = 2),
                        viewMode.classList.remove("active"),
                        viewModeMobile.classList.remove("active"),
                        this.mediaView.querySelector(".grid-2").classList.add("active"),
                        this.mediaViewMobile.querySelector(".grid-2").classList.add("active"))
                      : windowWidth <= 1100 && windowWidth >= 768
                        ? (column == 5 || column == 4 || column == 3) &&
                          ((column = 2),
                          viewMode.classList.remove("active"),
                          viewModeMobile.classList.remove("active"),
                          this.mediaView.querySelector(".grid-2").classList.add("active"),
                          this.mediaViewMobile.querySelector(".grid-2").classList.add("active"))
                        : windowWidth < 1299 && windowWidth > 1100
                          ? (column == 5 || column == 4) &&
                            ((column = 3),
                            viewMode.classList.remove("active"),
                            viewModeMobile.classList.remove("active"),
                            this.mediaView.querySelector(".grid-3").classList.add("active"),
                            this.mediaViewMobile.querySelector(".grid-3").classList.add("active"))
                          : windowWidth < 1700 &&
                            windowWidth >= 1299 &&
                            column == 5 &&
                            ((column = 4),
                            viewMode.classList.remove("active"),
                            viewModeMobile.classList.remove("active"),
                            this.mediaView.querySelector(".grid-4").classList.add("active"),
                            this.mediaViewMobile.querySelector(".grid-4").classList.add("active"))
                  : windowWidth < 768
                    ? (column == 3 || column == 4 || column == 5) &&
                      ((column = 2),
                      viewMode.classList.remove("active"),
                      viewModeMobile.classList.remove("active"),
                      this.mediaView.querySelector(".grid-2").classList.add("active"),
                      this.mediaViewMobile.querySelector(".grid-2").classList.add("active"))
                    : windowWidth < 992 && windowWidth >= 768
                      ? (column == 4 || column == 5) &&
                        ((column = 3),
                        viewMode.classList.remove("active"),
                        viewModeMobile.classList.remove("active"),
                        this.mediaView.querySelector(".grid-3").classList.add("active"),
                        this.mediaViewMobile.querySelector(".grid-3").classList.add("active"))
                      : windowWidth < 1600 &&
                        windowWidth >= 992 &&
                        column == 5 &&
                        ((column = 4),
                        viewMode.classList.remove("active"),
                        viewModeMobile.classList.remove("active"),
                        this.mediaView.querySelector(".grid-4").classList.add("active"),
                        this.mediaViewMobile.querySelector(".grid-4").classList.add("active")),
              this.initViewModeLayout(column))
            : ajaxLoading && this.initViewModeLayout(column);
    }
    changeBannerPositions(column) {
        const collectionProductGrid = document.getElementById("main-collection-product-grid"),
            productLists = [...collectionProductGrid?.querySelectorAll(".product")],
            banner1 = productLists.find((product) => product?.dataset?.productBanner == 1),
            banner2 = productLists.find((product) => product?.dataset?.productBanner == 2),
            banner3 = productLists.find((product) => product?.dataset?.productBanner == 3),
            bannerLists = [banner1, banner2, banner3].filter((banner) => banner);
        if (bannerLists.length === 0) {
            console.warn("No banners found to reposition.");
            return;
        }
        const getCurrentPosition = (banner) => {
                const currentIndex = productLists.indexOf(banner);
                return {
                    bannerNumber: banner?.dataset?.productBanner,
                    currentIndex,
                    originalIndex: parseInt(banner?.dataset?.firstPosition),
                };
            },
            getNextPosition = (info) => {
                let nextPosition = info.currentIndex;
                switch (column) {
                    case 2: {
                        info.bannerNumber == 1
                            ? (nextPosition = 2)
                            : info.bannerNumber == 2
                              ? (nextPosition = 5)
                              : info.bannerNumber == 3 && (nextPosition = 8),
                            collectionProductGrid?.classList.add("banner-full-width");
                        break;
                    }
                    case 3: {
                        info.bannerNumber == 3
                            ? (nextPosition = info.originalIndex)
                            : (nextPosition = info.originalIndex - 1);
                        break;
                    }
                    case 4: {
                        nextPosition = info.originalIndex;
                        break;
                    }
                    case 5: {
                        info.bannerNumber == 3
                            ? (nextPosition = info.originalIndex + 3)
                            : (nextPosition = info.originalIndex + 1);
                        break;
                    }
                    default:
                        collectionProductGrid?.classList.remove("banner-full-width");
                }
                return {
                    bannerNumber: info.bannerNumber,
                    originalIndex: info.originalIndex,
                    currentIndex: nextPosition,
                };
            },
            clearBanner = () => {
                bannerLists.forEach((banner) => {
                    collectionProductGrid?.removeChild(banner);
                });
            },
            setBannerPosition = (nextInfo) => {
                let productBefore = [...collectionProductGrid?.querySelectorAll(".product")][nextInfo.currentIndex];
                const bannerToAppend = bannerLists.find(
                    (banner) => banner?.dataset?.productBanner == nextInfo.bannerNumber
                );
                collectionProductGrid?.insertBefore(bannerToAppend, productBefore);
            },
            bannersNextInfo = bannerLists.map(getCurrentPosition).map(getNextPosition);
        clearBanner(), bannersNextInfo.forEach(setBannerPosition);
    }
    initViewModeLayout(column) {
        const productListing = document.getElementById("CollectionProductGrid").querySelector(".productListing");
        if (productListing) {
            switch (column) {
                case 1:
                    productListing.classList.remove("productGrid", "column-5", "column-4", "column-3", "column-2"),
                        productListing.classList.add("productList");
                    break;
                default:
                    switch (column) {
                        case 2:
                            productListing.classList.remove("productList", "column-5", "column-4", "column-3"),
                                productListing.classList.add("productGrid", "column-2");
                            break;
                        case 3:
                            productListing.classList.remove("productList", "column-5", "column-4", "column-2"),
                                productListing.classList.add("productGrid", "column-3");
                            break;
                        case 4:
                            productListing.classList.remove("productList", "column-5", "column-3", "column-2"),
                                productListing.classList.add("productGrid", "column-4");
                            break;
                        case 5:
                            productListing.classList.remove("productList", "column-4", "column-3", "column-2"),
                                productListing.classList.add("productGrid", "column-5");
                            break;
                    }
            }
            document.querySelector(".collection-masonry") && resizeAllGridItems(),
                document.querySelector(".collection-banner-adv") && this.changeBannerPositions(column);
        }
    }
    onClickModeButtonHandler(event) {
        event.preventDefault();
        var buttonElement = event.currentTarget,
            viewMode = this.mediaView.querySelector(".icon-mode.active"),
            column = parseInt(buttonElement.dataset.col);
        buttonElement.classList.contains("active") ||
            (viewMode.classList.remove("active"),
            buttonElement.classList.add("active"),
            this.mediaViewMobile.querySelectorAll(".icon-mode").forEach((element) => {
                var currentColum = parseInt(element.dataset.col);
                currentColum == column ? element.classList.add("active") : element.classList.remove("active");
            }),
            this.initViewModeLayout(column));
    }
    onClickModeButtonMobileHandler(event) {
        event.preventDefault();
        var buttonElement = event.currentTarget,
            viewMode = this.mediaViewMobile.querySelector(".icon-mode.active"),
            column = parseInt(buttonElement.dataset.col);
        buttonElement.classList.contains("active") ||
            (viewMode.classList.remove("active"),
            buttonElement.classList.add("active"),
            this.mediaView.querySelectorAll(".icon-mode").forEach((element) => {
                var currentColum = parseInt(element.dataset.col);
                currentColum == column ? element.classList.add("active") : element.classList.remove("active");
            }),
            this.initViewModeLayout(column));
    }
    onClickLimitButtonHandler(event) {
        event.preventDefault();
        var buttonElement = event.currentTarget;
        if (!buttonElement.classList.contains("is-active")) {
            var value = parseInt(buttonElement.querySelector(".text").dataset.value, 10);
            this.limitView.querySelector(".label-text").innerText = value;
            this.limitView.querySelector("[data-toggle]").setAttribute("aria-expanded", !1);
            this.limitView.querySelectorAll("[data-limited-view-item]").forEach((limitButton) => {
                limitButton.classList.remove("is-active");
            });
            buttonElement.classList.add("is-active");
            fetch("/cart/update.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify({ attributes: { pagination: String(value) } }),
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("Failed to update items per page");
                    }
                    delete Shopify.queryParams.page;
                    window.location.href = this.createURLHash();
                })
                .catch(() => {
                    alert("Unable to update items per page. Please try again.");
                });
        }
    }
    connectedCallback() {
        (this.onScrollHandler = this.onScroll.bind(this)), window.addEventListener("scroll", this.onScrollHandler, !1);
    }
    disconnectedCallback() {
        window.removeEventListener("scroll", this.onScrollHandler);
    }
    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop,
            offsetScroll = $("#CollectionProductGrid .productListing").offset().top + 100;
        var windowWidth = window.innerWidth;
        if (windowWidth < 1025)
            if (scrollTop > offsetScroll)
                if (
                    (requestAnimationFrame(this.showSticky.bind(this)),
                    document
                        .querySelector(".section-header-navigation")
                        .classList.contains("shopify-section-header-show"))
                ) {
                    var height = document.querySelector(".header-mobile").offsetHeight;
                    this.style.top = `${height}px`;
                } else
                    document
                        .querySelector(".section-header-mobile")
                        .classList.contains("shopify-section-header-hidden") && (this.style.top = 0);
            else requestAnimationFrame(this.hideSticky.bind(this));
        this.currentScrollTop = scrollTop;
    }
    hideSticky() {
        this.classList.remove("show-sticky", "animate"), this.closeDropdownPopupSticky();
    }
    showSticky() {
        this.classList.add("show-sticky", "animate"), this.closeDropdownPopupSticky();
    }
    closeModalClick() {
        (this.closeMobileModal = this.querySelector("[data-sorting][data-mobile] .close-mobile-modal")),
            this.closeMobileModal.addEventListener("click", () => {
                this.querySelector('[data-toggle][data-mobile="mobile"]').setAttribute("aria-expanded", !1),
                    document.body.classList.remove("toolbar-modal-open");
            });
    }
    closeDropdownPopupSticky() {
        this.querySelector(".label-tab") &&
            this.querySelectorAll(".label-tab").forEach((element) => {
                element.setAttribute("aria-expanded", !1);
            });
    }
    onBodyClickEvent(event) {
        this.querySelector("[data-toggle]") &&
            this.querySelectorAll("[data-toggle]").forEach((dropdownButton) => {
                if (dropdownButton.dataset.mobile === "mobile")
                    !this.querySelector("[data-sorting][data-mobile]").contains(event.target) &&
                        !dropdownButton.contains(event.target) &&
                        (dropdownButton.setAttribute("aria-expanded", !1),
                        document.body.classList.contains("toolbar-modal-open") &&
                            document.body.classList.remove("toolbar-modal-open"));
                else {
                    var contentDropdown = dropdownButton.nextElementSibling;
                    !contentDropdown.contains(event.target) &&
                        !dropdownButton.contains(event.target) &&
                        dropdownButton.setAttribute("aria-expanded", !1);
                }
            });
    }
}
customElements.define("toolbar-item", Toolbar);
//# sourceMappingURL=/cdn/shop/t/60/assets/toolbar.js.map?v=12727091737222511721775473813
